import React from 'react';
import { ImageElement } from '../../schema/image.schema';
import styles from '../../assets/css/image.module.css';

interface ImageComponentProps {
	element: ImageElement;
}

const ImageComponent: React.FC<ImageComponentProps> = ({ element }) => {
	const { src, alt, label, title } = element;

	return (
		<>
			<div className={`${styles['image-container']} ${element.tags.map((tag) => styles[tag]).join(' ')}`}>
				<img src={src} alt={alt} title={title} />
			</div>
			{label && <figcaption>{label}</figcaption>}
		</>
	);
};

export default ImageComponent;
